import React from 'react';
export function useControlledState(value, defaultValue, onUpdate) {
    const [innerValue, setInnerValue] = React.useState(defaultValue);
    const [wasControlled] = React.useState(value !== undefined);
    const isControlled = value !== undefined;
    if (wasControlled !== isControlled) {
        console.warn(`WARN: A component changed from ${wasControlled ? 'controlled' : 'uncontrolled'} to ${isControlled ? 'controlled' : 'uncontrolled'}.`);
    }
    const currentValueRef = React.useRef(isControlled ? value : defaultValue);
    React.useEffect(() => {
        currentValueRef.current = value;
    }, [value]);
    const setState = React.useCallback((newValue, ...args) => {
        if (!Object.is(currentValueRef.current, newValue)) {
            onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(newValue, ...args);
        }
        if (!isControlled) {
            currentValueRef.current = newValue;
            setInnerValue(newValue);
        }
    }, [isControlled, onUpdate]);
    return [isControlled ? value : innerValue, setState];
}
